import { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router';

import { useGetUser, useReserveNumber } from '@/api';
import { NumberBlock } from '@/components/AllNumbers/NumberBlock/NumberBlock.tsx';
import { Button } from '@/components/shared/Button';
import { useYMOnMount } from '@/hooks';
import { appRoutes } from '@/routes/app-routes.ts';
import { useChosenNumberStore, useModalStore } from '@/store';
import { formatNumber } from '@/utils';

import cn from './styles.module.sass';

export const NumberReservationContent = () => {
    const { chosenNumber, activeTariffSid, clearOnUnmount } = useChosenNumberStore();
    const { data: userData } = useGetUser();
    const { setIsReservationOpen } = useModalStore();
    const [errorText, setErrorText] = useState('');

    const { number, numberCost, minTariffPrice, operator, region, tariffs } = chosenNumber || {};

    const {
        mutateAsync: reserveNumber,
        isPending,
        isSuccess,
    } = useReserveNumber(formatNumber(number || '', true));

    const handleReserveNumber = async () => {
        const res = await reserveNumber({
            durationType: 'regular',
            selectedTariff: activeTariffSid,
        });

        if (res?.success) {
            clearOnUnmount();
        } else if (res?.errors) {
            setErrorText('Номер уже зарезервирован');
        }
    };

    const handleClick = () => {
        setIsReservationOpen(false);
    };

    useYMOnMount((isSuccess ? 'successful_' : 'show_') + 'reservation');

    return (
        <div className={cn.container}>
            {isSuccess ? (
                <div className={cn.success}>
                    <div className={cn.iconWrapper}>
                        <img src="/images/main/success_reservation.svg" alt="" />
                    </div>
                    <div className={cn.head}>
                        <h2>Номер успешно забронирован!</h2>
                        <div className={cn.description}>
                            <p>Управляй забронированными номерами в разделе "Брони"</p>
                            <p>Чтобы купить номер, добавь данные об абоненте и нажми Оплатить</p>
                        </div>
                    </div>
                    <Link className={cn.link} to={`/${appRoutes.myReservations}`}>
                        <Button onClick={handleClick}>Перейти в Брони</Button>
                    </Link>
                </div>
            ) : (
                <>
                    <div className={cn.head}>
                        <h2>Бронирование номера</h2>
                        <p>
                            Забронируй бесплатно на 24 часа.
                            <br />
                            Бронь можно отменить в любой момент
                        </p>
                    </div>
                    <NumberBlock
                        numberCost={numberCost ?? 0}
                        number={number || ''}
                        tariffMin={minTariffPrice || 0}
                        operator={operator || ''}
                        region={region || ''}
                        tariffs={tariffs || []}
                    />
                    {errorText && <p className={cn.errorText}>{errorText}</p>}
                    <div className={cn.reservationsAvailable}>
                        {userData ? (
                            `Количество забронированных номеров на сутки: ${userData.reservations.current} из ${userData.reservations.max}`
                        ) : (
                            <Skeleton />
                        )}
                    </div>
                    {isPending ? (
                        <Skeleton height={48} />
                    ) : (
                        <Button
                            disabled={
                                userData &&
                                userData.reservations.current >= userData.reservations.max
                            }
                            onClick={handleReserveNumber}
                        >
                            Забронировать
                        </Button>
                    )}
                </>
            )}
        </div>
    );
};
